/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePlaylistResponse
 */
export interface CreatePlaylistResponse {
    /**
     * The blockchain transaction hash
     * @type {string}
     * @memberof CreatePlaylistResponse
     */
    transactionHash?: string;
    /**
     * The blockchain block hash
     * @type {string}
     * @memberof CreatePlaylistResponse
     */
    blockHash?: string;
    /**
     * The blockchain block number/height
     * @type {number}
     * @memberof CreatePlaylistResponse
     */
    blockNumber?: number;
    /**
     * The ID of the created playlist
     * @type {string}
     * @memberof CreatePlaylistResponse
     */
    playlistId?: string;
}

/**
 * Check if a given object implements the CreatePlaylistResponse interface.
 */
export function instanceOfCreatePlaylistResponse(value: object): value is CreatePlaylistResponse {
    let isInstance = true;

    return isInstance;
}

export function CreatePlaylistResponseFromJSON(json: any): CreatePlaylistResponse {
    return CreatePlaylistResponseFromJSONTyped(json, false);
}

export function CreatePlaylistResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePlaylistResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactionHash': !exists(json, 'transaction_hash') ? undefined : json['transaction_hash'],
        'blockHash': !exists(json, 'block_hash') ? undefined : json['block_hash'],
        'blockNumber': !exists(json, 'block_number') ? undefined : json['block_number'],
        'playlistId': !exists(json, 'playlist_id') ? undefined : json['playlist_id'],
    };
}

export function CreatePlaylistResponseToJSON(value?: CreatePlaylistResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transaction_hash': value.transactionHash,
        'block_hash': value.blockHash,
        'block_number': value.blockNumber,
        'playlist_id': value.playlistId,
    };
}

